import { Builder } from '@builder.io/sdk';
import { WidgetEmbed } from './WidgetEmbed';

const WidgetEmbedConfig = {
  name: 'WidgetEmbed',
  defaultStyles: {
    margin: '0',
  },
  inputs: [
    {
      name: 'url',
      type: 'string',
      required: true,
    },
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'width',
      type: 'string',
      defaultValue: '100%',
    },
    {
      name: 'height',
      type: 'number',
      required: true,
    },
  ],
};

Builder.registerComponent(WidgetEmbed, WidgetEmbedConfig);
